export function loginDestination(next: string | null, from?: { pathname?: string; search?: string }): string {
  const candidate = next ? (next.startsWith("/") ? next : `/${next}`) : from?.pathname;
  if (!candidate || !/^\/(?:pricing|usage|character|payment\/[0-9a-f-]{36})$/.test(candidate)) return "/";
  // Router state is local; accept query strings only after a validated in-app path.
  return candidate + (!next && from?.search?.startsWith("?") ? from.search : "");
}
